<template>
  <div class="addeditaddress_page">
    <title-bar-back :title="title" :showBack="true" @back="back">
    </title-bar-back>

    <div class="container">
      <div class="form-container">
        <!-- 国家/地区选择 -->
        <div class="form-item" @click="selectCountry">
          <div class="form-label">国家/地区</div>
          <div class="content-box" :class="{ 'box-disabled': isCountryLocked }">
            <div
              class="input-display"
              :class="{ 'placeholder-style': !countryName }"
            >
              {{ countryName || "请选择国家" }}
            </div>
            <van-icon v-if="!isCountryLocked" name="arrow" class="arrow-icon" />
          </div>
        </div>

        <!-- 收货人姓名 -->
        <div class="form-item">
          <div class="form-label">收货人</div>
          <div class="content-box">
            <input
              class="input"
              type="text"
              v-model="name"
              placeholder="请填写收货人姓名"
            />
          </div>
        </div>

        <!-- 手机号码 -->
        <div class="form-item">
          <div class="form-label">手机号码</div>
          <div class="content-box">
            <div class="prefix-text">
              {{ countryCode === "CN" ? "+86" : "+61" }}
            </div>
            <input
              class="input"
              type="tel"
              v-model="phone"
              maxlength="11"
              placeholder="输入手机号码"
            />
          </div>
        </div>

        <!-- 所在区域 -->
        <div class="form-item" @click="addressSkuClick">
          <div class="form-label">
            {{
              countryCode === "CN" ? "省、市、区" : "州/省、城市/郊区、邮政编码"
            }}
          </div>
          <div class="content-box">
            <div
              class="input-display"
              :class="{ 'placeholder-style': !province }"
            >
              {{
                province
                  ? `${province} ${city} ${district}`
                  : countryCode === "CN"
                  ? "选择所在省、市、区"
                  : "选择所在州/省、城市/郊区、邮政编码"
              }}
            </div>
            <van-icon name="arrow" class="arrow-icon" />
          </div>
        </div>

        <!-- 详细地址 -->
        <div class="form-item">
          <div class="form-label">详细地址</div>
          <div class="content-box">
            <input
              class="input"
              type="text"
              v-model="addressLine"
              placeholder="请输入街道、楼牌号等详细地址"
            />
          </div>
        </div>

        <!-- 中国通关实名信息 -->
        <template v-if="countryCode === 'CN' && $appSource === 3">
          <!-- 身份证号码 -->
          <div class="form-item">
            <div class="form-label">身份证号码</div>
            <div class="content-box">
              <input
                class="input"
                type="text"
                v-model="idcardNo"
                placeholder="请填写收件人身份证号码"
              />
            </div>
          </div>

          <!-- 身份证照片上传 -->
          <div class="idcard-upload-section">
            <div class="section-title">上传身份证正反面</div>
            <div class="upload-box-row">
              <!-- 人像面 -->
              <div class="upload-box">
                <van-uploader
                  :after-read="file => uploadIdcard(file, 'idcard_front')"
                  accept="image/*"
                >
                  <img
                    v-if="idcardFrontUrl"
                    :src="idcardFrontUrl"
                    class="upload-img"
                  />
                  <div v-else class="upload-placeholder">
                    <van-icon
                      name="photograph"
                      size="32px"
                      color="#8a99a8"
                      style="margin-bottom: 6px;"
                    />
                    <span class="placeholder-text">上传人像面</span>
                  </div>
                </van-uploader>
              </div>
              <!-- 国徽面 -->
              <div class="upload-box">
                <van-uploader
                  :after-read="file => uploadIdcard(file, 'idcard_back')"
                  accept="image/*"
                >
                  <img
                    v-if="idcardBackUrl"
                    :src="idcardBackUrl"
                    class="upload-img"
                  />
                  <div v-else class="upload-placeholder">
                    <van-icon
                      name="photograph"
                      size="32px"
                      color="#8a99a8"
                      style="margin-bottom: 6px;"
                    />
                    <span class="placeholder-text">上传国徽面</span>
                  </div>
                </van-uploader>
              </div>
            </div>
          </div>

          <!-- 提示 -->
          <div class="customs-tip-container">
            <div class="customs-tip-text">海关实名需要</div>
            <div class="customs-tip-text">请上传符合海关要求的身份证照片。</div>
            <div class="customs-tip-text">
              1.请确保身份证正反面图片清晰、完整
            </div>
            <div class="customs-tip-text">
              2.身份证必须在有效期内，且为第二代身份证
            </div>
          </div>
        </template>

        <!-- 智能识别 -->
        <template v-if="countryCode === 'CN'">
          <div class="smart-parse-container">
            <div class="smart-header">
              <div class="smart-title">智能识别</div>
              <div
                class="smart-clear"
                @click="clearSmartText"
                v-if="smartAddressText"
              >
                清空
              </div>
            </div>
            <textarea
              v-model="smartAddressText"
              class="smart-textarea"
              placeholder="粘贴地址信息,可自动识别并填写如:收件人姓名,188********,浙江省 杭州市 xx区 xx街道 xxxxx"
              maxlength="200"
            ></textarea>
            <div class="smart-btn-row">
              <div class="smart-btn" @click="smartParse">识别</div>
            </div>
          </div>
        </template>

        <!-- 地址类型选择 -->
        <div class="type-select-row" v-if="!id && canChangeKind">
          <div
            class="type-btn"
            :class="{ 'type-btn-active': type === 1 }"
            @click="onTypeChange(1)"
          >
            店铺地址
          </div>
          <div
            class="type-btn"
            :class="{ 'type-btn-active': type === 3 }"
            @click="onTypeChange(3)"
          >
            客户地址
          </div>
        </div>
      </div>

      <!-- 设为默认 -->
      <div class="default-row">
        <div class="default-left">
          <div class="default-title">设为默认收货地址</div>
          <div class="default-desc">每次下单时会默认使用该地址</div>
        </div>
        <van-switch v-model="isDefaultBool" size="20" active-color="#DD9132" />
      </div>

      <!-- 删除按钮 -->
      <div class="delete-btn" @click="deleteAddress" v-if="id">
        删除收货地址
      </div>

      <!-- 底部保存 -->
      <div class="bottom-btn-container">
        <div class="save_btn" @click="saveAddress">保存</div>
      </div>
    </div>

    <!-- 省市区弹窗 -->
    <address-select-sheet
      v-if="customPopu"
      :show="customPopu"
      @close="customPopuClick"
      @getSelectAddress="getSelectAddress"
      :countryCode="countryCode"
      :province="province"
      :city="city"
      :district="district"
    ></address-select-sheet>

    <!-- 国家选择弹窗 -->
    <van-action-sheet
      v-model="showCountrySheet"
      :actions="countryActions"
      @select="onCountrySelect"
      cancel-text="取消"
      close-on-click-action
    />
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const AddressSelectSheet = () =>
  import("./components/SelectionStyle5AddressSheet").then(m => m.default || m);

export default {
  name: "AddEditAddress",
  components: {
    TitleBarBack,
    AddressSelectSheet
  },
  data() {
    return {
      title: "新增收货地址",
      id: "",
      type: 1, // 1: 店铺 3: 客户
      canChangeKind: false,

      // 国家
      countryCode: "CN",
      countryName: "中国",
      isCountryLocked: false,
      showCountrySheet: false,
      countryActions: [
        { name: "中国", code: "CN" },
        { name: "澳大利亚", code: "AU" }
      ],

      // 表单
      name: "",
      phone: "",
      province: "",
      city: "",
      district: "",
      addressLine: "",
      isDefaultBool: false,

      // 身份证
      idcardNo: "",
      idcardFrontUrl: "",
      idcardBackUrl: "",

      // 智能识别
      smartAddressText: "",

      customPopu: false
    };
  },
  computed: {
    isDefault() {
      return this.isDefaultBool ? 1 : 0;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let initialCountry = "CN";
      let initialCountryName = "中国";
      let isCountryLocked = false;

      const appSource = this.$appSource;
      const query = this.$route.query;

      if (query.title) {
        this.title = query.title;
      }

      if (query.type) {
        this.type = parseInt(query.type);
      }

      if (query.canChangeKind === "true" || query.canChangeKind === true) {
        this.canChangeKind = true;
      }

      if (appSource !== 3) {
        initialCountry = "CN";
        initialCountryName = "中国";
        isCountryLocked = true;
      } else {
        if (query.deliveryMode) {
          const mode = parseInt(query.deliveryMode);
          if (mode === 1) {
            initialCountry = "AU";
            initialCountryName = "澳大利亚";
            isCountryLocked = true;
          } else if (mode === 2) {
            initialCountry = "CN";
            initialCountryName = "中国";
            isCountryLocked = true;
          }
        } else if (query.countryCode) {
          initialCountry = query.countryCode;
          initialCountryName = query.countryCode === "CN" ? "中国" : "澳大利亚";
          isCountryLocked =
            query.isCountryLocked === "true" || query.isCountryLocked === true;
        }
      }

      this.countryCode = initialCountry;
      this.countryName = initialCountryName;
      this.isCountryLocked = isCountryLocked;

      if (query.id) {
        this.id = query.id;
        this.title = "编辑收货地址";
        this.getdata();
      }
    },
    getdata() {
      this.$store
        .dispatch("mine/getAddressById", { params: { id: this.id } })
        .then(res => {
          this.name = res.name || "";
          this.phone = res.phone || "";
          this.addressLine = res.addressLine || "";
          this.province = res.province || "";
          this.city = res.city || "";
          this.district = res.district || "";
          this.isDefaultBool = res.isDefault === 1;
          this.idcardNo = res.idcardNo || "";
          this.idcardFrontUrl = res.idcardFrontUrl || "";
          this.idcardBackUrl = res.idcardBackUrl || "";

          // 澳洲地址处理
          if (
            this.$appSource === 3 &&
            (res.country === "澳大利亚" || res.countryCode === "AU")
          ) {
            this.countryCode = "AU";
            this.countryName = "澳大利亚";
          } else {
            this.countryCode = "CN";
            this.countryName = "中国";
          }

          if (this.$appSource !== 3) {
            this.countryCode = "CN";
            this.countryName = "中国";
            this.isCountryLocked = true;
          }
        })
        .catch(() => {});
    },
    back() {
      this.$router.back();
    },
    selectCountry() {
      if (this.isCountryLocked) return;
      this.showCountrySheet = true;
    },
    onCountrySelect(action) {
      this.countryCode = action.code;
      this.countryName = action.name;
      // 重置数据
      this.province = "";
      this.city = "";
      this.district = "";
      this.idcardNo = "";
      this.idcardFrontUrl = "";
      this.idcardBackUrl = "";
      this.showCountrySheet = false;
    },
    addressSkuClick() {
      this.customPopu = true;
    },
    customPopuClick() {
      this.customPopu = false;
    },
    getSelectAddress(address) {
      if (address && address.length >= 3) {
        this.province = address[0].areaName;
        this.city = address[1].areaName;
        this.district = address[2].areaName;
      }
      this.customPopuClick();
    },
    onTypeChange(type) {
      this.type = type;
    },
    uploadIdcard(file, sourceId) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true
      });
      const params = {
        file: file.file,
        data: {
          kind: "identity",
          sourceId: sourceId
        }
      };
      this.$store
        .dispatch("mine/upload", { params })
        .then(data => {
          this.$toast.clear();
          if (data && data.linkUrl) {
            if (sourceId === "idcard_front") {
              this.idcardFrontUrl = data.linkUrl;
            } else {
              this.idcardBackUrl = data.linkUrl;
            }
            this.$toast.success("上传成功");
          } else {
            this.$toast.fail("上传失败");
          }
        })
        .catch(() => {
          this.$toast.clear();
          this.$toast.fail("上传异常");
        });
    },
    clearSmartText() {
      this.smartAddressText = "";
    },
    smartParse() {
      if (!this.smartAddressText) {
        this.$toast("请输入地址信息");
        return;
      }
      this.$toast.loading({
        message: "识别中...",
        forbidClick: true
      });
      this.$store
        .dispatch("mine/addressConsigneeInformation", {
          params: { addr: this.smartAddressText }
        })
        .then(res => {
          this.$toast.clear();
          this.name = res.name || "";
          this.phone = res.phone || "";
          this.province = res.province || "";
          this.city = res.city || "";
          this.district = res.district || "";
          this.addressLine = res.addressLine || "";
          this.$toast.success("识别成功");
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    saveAddress() {
      if (!this.name.trim()) {
        this.$toast("请填写收货人姓名");
        return;
      }
      if (!this.phone.trim()) {
        this.$toast("请填写手机号码");
        return;
      }
      const phoneRegs = /^(1[3456789])\d{9}$/;
      if (this.countryCode === "CN" && !phoneRegs.test(this.phone.trim())) {
        this.$toast("手机号码格式不正确");
        return;
      }
      if (!this.province || !this.city || !this.district) {
        this.$toast("请选择所在区域");
        return;
      }
      if (!this.addressLine.trim()) {
        this.$toast("请填写详细地址");
        return;
      }

      if (this.countryCode === "CN" && this.$appSource === 3) {
        if (!this.idcardNo) {
          this.$toast("请填写身份证号码");
          return;
        }
        const idcardRegs = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!idcardRegs.test(this.idcardNo.trim())) {
          this.$toast("身份证号码格式不正确");
          return;
        }
        if (!this.idcardFrontUrl) {
          this.$toast("请上传身份证人像面照片");
          return;
        }
        if (!this.idcardBackUrl) {
          this.$toast("请上传身份证国徽面照片");
          return;
        }
      }

      const params = {
        name: this.name.trim(),
        idcardName: this.name.trim(),
        phone: this.phone.trim(),
        province: this.province,
        city: this.city,
        district: this.district,
        addressLine: this.addressLine.trim(),
        isDefault: this.isDefault,
        type: this.type,
        country: this.countryName,
        countryCode: this.countryCode,
        idcardNo:
          this.countryCode === "CN" && this.$appSource === 3
            ? this.idcardNo
            : "",
        idcardFrontUrl:
          this.countryCode === "CN" && this.$appSource === 3
            ? this.idcardFrontUrl
            : "",
        idcardBackUrl:
          this.countryCode === "CN" && this.$appSource === 3
            ? this.idcardBackUrl
            : ""
      };

      let action = "mine/addAddress";
      if (this.id) {
        params.id = this.id;
        action = "mine/updateAddress";
      }

      this.$store
        .dispatch(action, { params })
        .then(res => {
          this.$toast.success(this.id ? "修改成功" : "保存成功");

          const query = this.$route.query;
          if (query.previousPage === "pur") {
            localStorage.setItem("pur-address", JSON.stringify(res));
            this.$router.go(-2);
            return;
          }
          if (query.previousPage === "exchangeMilkPur") {
            localStorage.setItem(
              "exchange-milk-pur-address",
              JSON.stringify(res)
            );
            this.$router.go(-2);
            return;
          }
          if (query.previousPage === "milkPlan") {
            if (query.switchPur === "one") {
              localStorage.setItem(
                "exchange-milk-plan-one-address",
                JSON.stringify(res)
              );
              localStorage.setItem(
                "exchange-milk-plan-one-parcelId",
                query.parcelId
              );
            } else {
              localStorage.setItem(
                "exchange-milk-plan-all-address",
                JSON.stringify(res)
              );
            }
            this.$router.go(-2);
            return;
          }

          setTimeout(() => {
            this.$router.back();
          }, 1000);
        })
        .catch(() => {});
    },
    deleteAddress() {
      this.$dialog
        .confirm({
          message: "确定要删除该地址吗？",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          this.$store
            .dispatch("mine/deleteAddress", {
              params: { id: this.id }
            })
            .then(() => {
              this.$toast.success("删除成功");
              localStorage.removeItem("pur-address");
              localStorage.removeItem("exchange-milk-pur-address");
              localStorage.removeItem("exchange-milk-plan-one-address");
              localStorage.removeItem("exchange-milk-plan-all-address");
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.addeditaddress_page {
  background-color: #f8f8f8;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 100px;
}

.container {
  box-sizing: border-box;
  padding-bottom: 20px;
}

.form-container {
  padding: 15px 15px 5px 15px;
  background-color: white;
  text-align: left;
}

/* 小程序表单 formItem 的样式复刻 */
.form-item {
  display: block;
  width: 100%;
  margin-bottom: 14px;
  box-sizing: border-box;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #333333;
  font-weight: 600;
  margin-bottom: 8px;
  padding-left: 2px;
  box-sizing: border-box;
}

.content-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 46px;
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 0 12px;
  box-sizing: border-box;
  transition: border-color 0.2s ease-in-out;

  &:active {
    border-color: #cccccc;
  }
}

.box-disabled {
  background-color: #fafafa;
  border-color: #f0f0f0;
}

.prefix-text {
  font-size: 14px;
  color: #333333;
  font-weight: 500;
  margin-right: 10px;
  flex-shrink: 0;
}

.input {
  flex: 1;
  height: 100%;
  font-size: 14px;
  color: #333333;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: #cccccc;
    font-size: 14px;
  }
}

.input-display {
  flex: 1;
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 14px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.placeholder-style {
  color: #cccccc !important;
}

.arrow-icon {
  font-size: 16px;
  margin-left: 8px;
  flex-shrink: 0;
  opacity: 0.8;
  color: #999;
}

/* 地址类型选择 */
.type-select-row {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  padding-top: 0;
  gap: 12px;
}

.type-btn {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 40px;
  border: 1px solid #999;
  background-color: #fff;
  font-size: 14px;
  color: #333;
}

.type-btn-active {
  background: #dd9132;
  border-color: #dd9132;
  color: #fff;
}

/* 智能识别 */
.smart-parse-container {
  padding: 5px 0;
  margin-bottom: 14px;
}

.smart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-left: 2px;
}

.smart-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.smart-clear {
  font-size: 13px;
  color: #999;
}

.smart-textarea {
  width: 100%;
  height: 90px;
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  resize: none;
  outline: none;
  &::placeholder {
    color: #ccc;
  }
}

.smart-btn-row {
  display: flex;
  justify-content: flex-end;
}

.smart-btn {
  width: 60px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #333;
  color: #fff;
  font-size: 13px;
  border-radius: 14px;
}

/* 身份证上传及海关提示 */
.idcard-upload-section {
  padding: 5px 0;
  margin-bottom: 14px;
}

.section-title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  margin-bottom: 8px;
  padding-left: 2px;
}

.upload-box-row {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.upload-box {
  flex: 1;
  height: 110px;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  ::v-deep .van-uploader,
  ::v-deep .van-uploader__wrapper,
  ::v-deep .van-uploader__upload,
  ::v-deep .van-uploader__input-wrapper {
    width: 100%;
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.upload-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.placeholder-text {
  font-size: 12px;
  color: #8a99a8;
}

.customs-tip-container {
  padding: 12px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 6px;
  margin-bottom: 14px;
}

.customs-tip-text {
  font-size: 13px;
  color: #faad14;
  line-height: 1.6;
}

/* 设为默认 */
.default-row {
  margin-top: 10px;
  background-color: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}

.default-left {
  flex: 1;
}

.default-title {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
}

.default-desc {
  font-size: 12px;
  color: #999;
}

/* 删除按钮 */
.delete-btn {
  margin-top: 10px;
  background-color: #fff;
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #ff2121;
}

/* 底部保存按钮 */
.bottom-btn-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: #fff;
  padding: 10px 15px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
}

.save_btn {
  background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  border-radius: 44px;
  padding: 14px 0;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
</style>
